import type { NuxtApp } from '#app/nuxt';
import { defineNuxtPlugin, useRouter } from '#imports';
import { initMatomo } from '~/utils/matomo/init';
import { requestCallback, registerMatomoRouter } from '~/utils/matomo/registerRouterHook';
import { defer } from '../utils/requestIdleCallback';

export default defineNuxtPlugin((nuxt: NuxtApp) => {
    /** Ensure this plugin only runs on the client side. */
    if (!process.client) {
        return;
    }

    const router = useRouter();

    defer(async () => {
        const enabled = await initMatomo(nuxt);

        if (enabled) {
            /** Requesting callback for the current route. */
            await requestCallback(nuxt, router.currentRoute.value, null);

            /** Adding router callback. */
            registerMatomoRouter(router, nuxt);
        }
    });
})
